export function normalizeCep(value) {
    if (!value)
        return value

    const re       = /^([\d]{2})\.?([\d]{3})\-?([\d]{3})/
    const onlyNums = value.replace(/\D/g, '').substr(0, 8)

    return onlyNums.replace(re, '$1.$2-$3')
}